export const VIEWPORT_EDITABLE_KEY_GUARD_MARKER = 'KAIROS_VIEWPORT_EDITABLE_KEY_GUARD';

const EDITABLE_ROLES = new Set(['textbox', 'searchbox']);

const hasEditableRole = (element) => {
  const role = String(element?.getAttribute?.('role') || '').trim().toLowerCase();
  return EDITABLE_ROLES.has(role);
};

const contentEditableState = (element) => {
  if (!element || typeof element.getAttribute !== 'function') return null;
  const value = element.getAttribute('contenteditable');
  if (value == null) return null;
  const normalized = String(value).trim().toLowerCase();
  // HTML treats the boolean attribute, "true", and "plaintext-only" as editable;
  // only the explicit "false" token creates an inert editing boundary.
  return normalized === 'false' ? false : true;
};

const hasEditableAncestor = (target) => {
  let element = target;
  while (element) {
    if (hasEditableRole(element)) return true;
    const editableState = contentEditableState(element);
    if (editableState != null) return editableState;
    element = element.parentElement;
  }
  return false;
};

export const isViewportEditableTarget = (target) => {
  if (!target) return false;
  const tagName = String(target.tagName || '').toUpperCase();
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tagName)) return true;
  if (target.isContentEditable) return true;
  return hasEditableAncestor(target);
};
